"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.promptDef = void 0;
exports.handle = handle;
const path = __importStar(require("path"));
const fs = __importStar(require("fs-extra"));
const dist_1 = require("../../../fs/dist");
exports.promptDef = {
    name: 'refine-design',
    description: 'Load a design doc and related thread chat history, return a refinement proposal prompt.',
    arguments: [
        { name: 'designId', description: 'Design document ID', required: true },
    ],
};
async function handle(root, args) {
    const designId = args['designId'];
    if (!designId)
        throw new Error('designId is required');
    // Primary (agent-supplied) id → suggest-on-miss.
    const { filePath } = await (0, dist_1.resolveDocIdOrThrow)(root, designId);
    const designContent = await fs.readFile(filePath, 'utf8');
    // Load chats from the thread-level chats dir (sibling of the design file)
    const threadDir = path.dirname(filePath);
    const chatsDir = path.join(threadDir, 'chats');
    const chatSections = [];
    if (await fs.pathExists(chatsDir)) {
        const chatFiles = (await fs.readdir(chatsDir))
            .filter(f => f.endsWith('.md'))
            .sort();
        for (const f of chatFiles) {
            const content = await fs.readFile(path.join(chatsDir, f), 'utf8');
            chatSections.push(`## chat: ${path.basename(f, '.md')}\n\n${content}`);
        }
    }
    const combined = [`## design: ${designId}\n\n${designContent}`, ...chatSections].join('\n\n---\n\n');
    return {
        description: `Refine design ${designId}`,
        messages: [
            { role: 'user', content: { type: 'text', text: combined } },
            {
                role: 'user',
                content: {
                    type: 'text',
                    text: 'Review the design document and chat history. Propose concrete refinements, clarifications, or additions to improve the design.',
                },
            },
        ],
    };
}
